import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Phone, MessageCircle, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import FloatingWhatsApp from './FloatingWhatsApp';

const ElettricistaCentroRoma = () => {
  const handleCall = () => window.location.href = 'tel:3287686356';
  const handleWhatsApp = () => window.open('https://wa.me/393287686356?text=Ciao,%20ho%20un%20guasto%20elettrico%20urgente%20in%20Centro%20Roma.', '_blank');

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <Helmet>
        <title>Elettricista Centro Roma H24 - Arrivo in 60 Min | 328 768 6356</title>
        <meta name="description" content="Elettricista Centro Roma H24. Salvavita, blackout, guasti. Arrivo in 60 minuti. Certificati DM 37/08. Tel: 328 768 6356" />
        <link rel="canonical" href={`${window.location.origin}/elettricista-centro-roma`} />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        
        <section className="bg-gradient-to-br from-yellow-50 to-blue-50 py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <div className="bg-yellow-500 text-gray-900 px-6 py-3 rounded-lg inline-block font-bold mb-4 animate-pulse">
                ⚡ GUASTO ELETTRICO CENTRO ROMA
              </div>
              
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                Elettricista Centro Roma H24
              </h1>
              
              <p className="text-2xl font-bold text-blue-700 mb-6">
                Arriviamo in 60 minuti • Anche in ZTL
              </p>
              
              <div className="bg-white p-6 rounded-lg shadow-xl mb-8">
                <p className="text-xl font-bold text-gray-900 mb-4">Guasti Risolti Subito:</p>
                <div className="grid md:grid-cols-2 gap-3 text-left">
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>⚡ Salvavita che scatta</span></div>
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>💡 Blackout totale</span></div>
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>🔌 Prese non funzionano</span></div>
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>⚠️ Cortocircuiti</span></div>
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>🔧 Quadro elettrico</span></div>
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>✅ Certificazione DM 37/08</span></div>
                </div>
              </div>
              
              <div className="flex flex-col gap-4 max-w-lg mx-auto">
                <Button onClick={handleWhatsApp} size="lg" className="bg-orange-500 hover:bg-orange-600 text-white text-2xl px-12 py-8 font-bold shadow-2xl animate-pulse">
                  <MessageCircle className="mr-3 h-8 w-8" />
                  WHATSAPP ORA
                </Button>
                <Button onClick={handleCall} size="lg" className="bg-blue-700 hover:bg-blue-800 text-white text-xl px-10 py-7 font-bold">
                  <Phone className="mr-3 h-7 w-7" />
                  CHIAMA: 328 768 6356
                </Button>
              </div>
              
              <p className="mt-8 text-lg text-gray-700">
                <strong>Zone:</strong> Centro Storico, Trevi, Pantheon, Campo de' Fiori, Trastevere, Monti
              </p>
            </div>
          </div>
        </section>

        <Footer />
        <FloatingWhatsApp />
      </div>
    </>
  );
};

export default ElettricistaCentroRoma;
